import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    display: flex;
    flex-direction: column;

    & > a {
        border-bottom: 1px solid ${ThemeColors.getGrayColor(0.1)};
    }
    & > a:first-child {
        border-top: 1px solid ${ThemeColors.getGrayColor(0.1)};
    }
`
